import { render, staticRenderFns } from "./gkDialog.vue?vue&type=template&id=2f3bea8c"
import script from "./gkDialog.vue?vue&type=script&lang=js"
export * from "./gkDialog.vue?vue&type=script&lang=js"
import style0 from "./gkDialog.vue?vue&type=style&index=0&id=2f3bea8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports